import { IconInfo20 } from '@lightspeed/unified-components-helios-theme/react'
import React, { FunctionComponent } from 'react'

type Props = {
  message: React.ReactNode
}

/**
 * Banner to show an informational message above the payment input
 */
export const PaymentInfoBanner: FunctionComponent<Props> = ({ message }) => {
  return (
    // Can't use helios <Banner> because it justifies all the text to the centre
    <div className="wr-payment-info-banner vd-banner vd-banner--info">
      <div className="vd-banner-wrapper vd-flex vd-flex--justify-between">
        <span className="vd-flex vd-flex--align-center" style={{ gap: '8px' }}>
          <IconInfo20 aria-hidden="true" />
          {message}
        </span>
      </div>
    </div>
  )
}
